module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-left"
  }, [_c('div', {
    staticClass: "columns documents",
    class: {
      'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.modals.POA.active
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar', 'has-text-left': _vm.Language != 'fa' && _vm.Language != 'ar'
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t("please_select_country")))]), _vm._v(" "), _c('label', {
    staticClass: "label",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    attrs: {
      "for": "country"
    }
  }, [_vm._v(_vm._s(this.$t('country').tTitle()))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.modals.POA.country),
      expression: "modals.POA.country"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('country')
    },
    attrs: {
      "data-vv-as": this.$t('country').tTitle(),
      "name": "country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.modals.POA, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.countries), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('country')),
      expression: "errors.has('country')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('country')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.modals.POA.country !== '') ? _c('div', {
    staticClass: "button is-success is-pulled-right",
    on: {
      "click": function($event) {
        return _vm.setCountry()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("set_country")))]) : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "modal-foot"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.modals.POA.active = false, _vm.modals.POA.country = ''
      }
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('div', {
    staticClass: "is-clearfix"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large"
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-image is-primary"
  }, [(_vm.documents.frontID === false) ? _c('Dropzone', {
    ref: "myVueDropzone_1",
    staticClass: "dropzone",
    attrs: {
      "id": "myVueDropzone_1",
      "useCustomSlot": true,
      "use-font-awesome": true,
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-success": _vm.showSuccess,
      "vdropzone-sending": function($event) {
        var i = arguments.length, argsArray = Array(i);
        while ( i-- ) argsArray[i] = arguments[i];

        return _vm.sending.apply(void 0, argsArray.concat( ['id-front'], ['ple'] ))
      }
    }
  }, [_c('div', {
    staticClass: "dropzone-custom-content"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('drop_files_upload')))])])]) : _vm._e(), _vm._v(" "), (_vm.documents.frontID === 'approved') ? _c('div', {
    staticClass: "status success"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]) : (_vm.documents.frontID === 'pending') ? _c('div', {
    staticClass: "status pending"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-hourglass"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('document_received')))])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('proof_of_id_instructions').tUpper()) + " /\n                "), _c('small', [_vm._v(_vm._s(_vm.$t('front_of_id').tTitle()))])])])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content attention"
  }, [_vm._v(_vm._s(_vm.$t('passport_ple_different')))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "is-marginless is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('documents_must_contain_all_of_the_following_details')))]), _vm._v(" "), _c('ul', {
    staticClass: "instructions",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('cc_requirements_1')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('document_req_color')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('your_full_name')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('a_unique_id_number')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('your_birthdate')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('your_place_of_birth')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('a_visible_photo')))]), _vm._v(" "), (_vm.Language == 'th') ? _c('li', [_vm._v(_vm._s(_vm.$t('your_signature')))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('your_nationality')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('issue_date')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('expiry_date')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-image"
  }, [(_vm.documents.backID === false) ? _c('Dropzone', {
    ref: "myVueDropzone_2",
    staticClass: "dropzone",
    attrs: {
      "id": "myVueDropzone_2",
      "useCustomSlot": true,
      "use-font-awesome": true,
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-success": _vm.showSuccess,
      "vdropzone-sending": function($event) {
        var i = arguments.length, argsArray = Array(i);
        while ( i-- ) argsArray[i] = arguments[i];

        return _vm.sending.apply(void 0, argsArray.concat( ['id-back'], ['ple'] ))
      }
    }
  }, [_c('div', {
    staticClass: "dropzone-custom-content"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('drop_files_upload')))])])]) : _vm._e(), _vm._v(" "), (_vm.documents.backID === 'approved') ? _c('div', {
    staticClass: "status success"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]) : (_vm.documents.backID === 'pending') ? _c('div', {
    staticClass: "status pending"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-hourglass"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('document_received')))])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('proof_of_id_instructions').tUpper()) + " /\n                "), _c('small', [_vm._v(_vm._s(_vm.$t('back_of_id').tTitle()))])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "is-marginless",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('documents_must_contain_all_of_the_following_details')))]), _vm._v(" "), _c('ul', {
    staticClass: "instructions",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('cc_requirements_1')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('document_req_color')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('your_full_name')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('a_unique_id_number')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('your_birthdate')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('your_place_of_birth')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('a_visible_photo')))]), _vm._v(" "), (_vm.Language == 'th') ? _c('li', [_vm._v(_vm._s(_vm.$t('your_signature')))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('your_nationality')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('issue_date')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('expiry_date')))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns documents",
    class: {
      'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-image"
  }, [(_vm.userHasCountry) ? [(_vm.documents.residence === false) ? _c('Dropzone', {
    ref: "myVueDropzone_3",
    staticClass: "dropzone",
    attrs: {
      "id": "myVueDropzone_3",
      "useCustomSlot": true,
      "use-font-awesome": true,
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-success": _vm.showSuccess,
      "vdropzone-sending": function($event) {
        var i = arguments.length, argsArray = Array(i);
        while ( i-- ) argsArray[i] = arguments[i];

        return _vm.sending.apply(void 0, argsArray.concat( ['address-proof'], ['poa'] ))
      }
    }
  }, [_c('div', {
    staticClass: "dropzone-custom-content"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('drop_files_upload')))])])]) : _vm._e(), _vm._v(" "), (_vm.documents.residence === 'approved') ? _c('div', {
    staticClass: "status success"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]) : (_vm.documents.residence === 'pending') ? _c('div', {
    staticClass: "status pending"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-hourglass"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('document_received')))])])]) : _vm._e()] : [_c('a', {
    staticClass: "countrySelect",
    on: {
      "click": function($event) {
        _vm.modals.POA.active = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('please_select_your_country')))])]], 2), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(_vm.$t('proof_of_residence').tUpper()))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v(_vm._s(_vm.$t('proof_of_residence_instructions').tTitle()))])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "is-marginless",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('documents_must_contain_all_of_the_following_details')))]), _vm._v(" "), _c('ul', {
    staticClass: "instructions",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('full_copy_of_the_document')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('your_full_name')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('your_physical_address')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('recent_date')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('must_be_a_utility_bill')))])])])])])]), _vm._v(" "), (_vm.hasIslamicTA) ? _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-image"
  }, [(_vm.documents.islamic === false) ? _c('Dropzone', {
    ref: "myVueDropzone_4",
    staticClass: "dropzone",
    attrs: {
      "id": "myVueDropzone_4",
      "useCustomSlot": true,
      "use-font-awesome": true,
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-success": _vm.showSuccess,
      "vdropzone-sending": function($event) {
        var i = arguments.length, argsArray = Array(i);
        while ( i-- ) argsArray[i] = arguments[i];

        return _vm.sending.apply(void 0, argsArray.concat( ['islamic'], ['por'] ))
      }
    }
  }, [_c('div', {
    staticClass: "dropzone-custom-content"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('drop_files_upload')))])])]) : _vm._e(), _vm._v(" "), (_vm.documents.islamic === 'approved') ? _c('div', {
    staticClass: "status success"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]) : (_vm.documents.islamic === 'pending') ? _c('div', {
    staticClass: "status pending"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-hourglass"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('document_received')))])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(_vm.$t('islamic_account').tUpper()))])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "is-marginless",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('documents_must_contain_all_of_the_following_details')))]), _vm._v(" "), _c('ul', {
    staticClass: "instructions",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('islamic_documents_instructions')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('full_copy_of_the_document')))])])])])])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.otherArray), function(rowGroup) {
    return _c('div', {
      key: 'rowGroup-' + rowGroup,
      staticClass: "columns documents",
      class: {
        'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
      }
    }, [_vm._l((rowGroup), function(o) {
      return _c('div', {
        key: o,
        staticClass: "column"
      }, [_c('div', {
        staticClass: "card"
      }, [_c('div', {
        staticClass: "card-image"
      }, [_c('Dropzone', {
        ref: "'myVueDropzone_other' + o",
        refInFor: true,
        staticClass: "dropzone",
        attrs: {
          "id": 'myVueDropzone_other' + o,
          "useCustomSlot": true,
          "use-font-awesome": true,
          "options": _vm.dropzoneOptions
        },
        on: {
          "vdropzone-success": _vm.showSuccess,
          "vdropzone-sending": function($event) {
            var i = arguments.length, argsArray = Array(i);
            while ( i-- ) argsArray[i] = arguments[i];

            return _vm.sending.apply(void 0, argsArray.concat( ['other-' + o], ['other'] ))
          }
        }
      }, [_c('div', {
        staticClass: "dropzone-custom-content"
      }, [_c('div', {
        staticClass: "subtitle"
      }, [_vm._v(_vm._s(_vm.$t('drop_files_upload')))])])])], 1), _vm._v(" "), _c('div', {
        staticClass: "card-content"
      }, [_c('div', {
        staticClass: "media"
      }, [_c('div', {
        staticClass: "media-content",
        class: {
          'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
        }
      }, [_c('p', {
        staticClass: "title is-4"
      }, [_vm._v(_vm._s(_vm.$t('other').tUpper()))]), _vm._v(" "), _c('p', {
        staticClass: "subtitle is-6"
      }, [_vm._v(_vm._s(_vm.$t('other_documents_instructions').tTitle()))])])]), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('h4', {
        staticClass: "is-marginless",
        class: {
          'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
        }
      }, [_vm._v(_vm._s(_vm.$t('documents_must_contain_all_of_the_following_details')))]), _vm._v(" "), _c('ul', {
        staticClass: "instructions",
        class: {
          'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
        }
      }, [_c('li', [_vm._v(_vm._s(_vm.$t('full_copy_of_the_document')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('your_full_name')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('your_residential_address')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('date_of_issue')))])])])])])])
    }), _vm._v(" "), (rowGroup.length < _vm.columnsPerRow && _vm.totalOthers < _vm.maxOthers) ? _c('div', {
      staticClass: "column"
    }, [_c('div', {
      staticClass: "card add"
    }, [_c('div', {
      staticClass: "card-image has-text-centered",
      on: {
        "click": _vm.addOthers
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('add_another_document')))])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "media-content",
      class: {
        'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
      }
    }, [_c('p', {
      staticClass: "title is-4"
    }, [_vm._v(_vm._s(_vm.$t('add_document').tUpper()))]), _vm._v(" "), _c('p', {
      staticClass: "subtitle is-6"
    }, [_vm._v(_vm._s(_vm.$t('click_to_add_another_document').tTitle()))])]), _vm._v(" "), _c('div', {
      staticClass: "content",
      class: {
        'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
      }
    }, [(!_vm.isCorporate()) ? _c('p', {
      staticClass: "is-marginless"
    }, [_vm._v(_vm._s(_vm.$t('add_up_to_4_extra_documents')))]) : _c('p', {
      staticClass: "is-marginless",
      class: {
        'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
      }
    }, [_vm._v(_vm._s(_vm.$t('add_up_to_10_extra_documents')))])])])])]) : _vm._e()], 2)
  }), _vm._v(" "), _c('p', {
    staticClass: "email-note",
    class: {
      'has-text-right direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('for_further_info_attach')))])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-size-2"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78bcdac8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/UploadDocuments.vue
// module id = 789
// module chunks = 0